import { render } from "./ResourceCard.vue?vue&type=template&id=ef700702"
import script from "./ResourceCard.vue?vue&type=script&lang=js"
export * from "./ResourceCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__